<template>
  <div>
    <edit-case ref="caseInfoEditRef" />
    <the-sidebar v-if="isEditMode && canViewActionSideBar" />
  </div>
</template>

<script>
import { EditCase } from './components';
import TheSidebar from '@/components/layout/TheSideBar.vue';

export default {
  name: 'EditRequestView',
  components: {
    EditCase,
    TheSidebar,
  },
  data: () => ({
    tabId: null,
    requestInfo: {},
  }),
};
</script>
